import axios from '@/utils/request/index.js'

// 公有凭证
const getPublicAuth = async (body) => {
  try {
    const { data } = await axios.post('/file/getPublicImageUploadAuth', {
      ...body,
    })
    return data.data
  } catch (error) {

    throw error
  }
}

// 组件凭证
const getFieldAuth = async (body) => {
  try {
    const { data } = await axios.post('/form/field/getUploadToken', {
      ...body,
    })
    return data.data
  } catch (error) {

    throw error
  }
}

// 私有凭证
const getPrivateAuth = async (body) => {
  try {
    const { data } = await axios.post('/file/getPrivateImageUploadAuth', {
      ...body,
    })
    return data.data
  } catch (error) {

    throw error
  }
}

const save = async (body) => {
  try {
    const { data } = await axios.post('/file/save', {
      ...body,
    })
    return data.data
  } catch (error) {

    throw error
  }
}

const getValidUrl = async (body) => {
  try {
    const { data } = await axios.post('/file/getValidUrl', {
      ...body,
    })
    return data.data
  } catch (error) {

    throw error
  }
}

const appendixList = async (body) => {
  try {
    const { data } = await axios.post('/file/search', {
      ...body,
    })
    return data.data
  } catch (error) {

    throw error
  }
}

const appendixUpload = async (body) => {
  try {
    const { data } = await axios.post('/file/bindCard', {
      ...body,
    })
    return data.data
  } catch (error) {

    throw error
  }
}

const myFileUsedRecord = async (body) => {
  try {
    const { data } = await axios.post('/file/myFileUsedRecord', {
      ...body,
    })
    return data.data
  } catch (error) {

    throw error
  }
}

export default {
  getPublicAuth,
  getFieldAuth,
  getPrivateAuth,
  getValidUrl,
  save,
  appendixList,
  appendixUpload,
  myFileUsedRecord,
}